import React, {useEffect, useState} from 'react';
import {setPriceCyclesDescription, checkRegularPayment, checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';

const ProgramDetails = ({data, monthlyPaymentsSummary, programDescription, currentSubscriber, generalDetails, offerName: offerNameProp}) => {
  let servicePayments;
  const [programDetail, setProgramDetail] = useState(programDescription?.programDescriptionDetails[0]?.programDescription);
  const [offerName, setOfferName] = useState(programDescription?.programDescriptionDetails[0]?.offerName ?? offerNameProp);
  const pricePlanDetailDesc = programDescription?.futurePPDetailDesc || programDescription?.pricePlanDetailDesc || '';
  const title = data.programDetailsTopic.value === '' ? 'פרטי התוכנית' : data.programDetailsTopic.value;
  const showServicePaymentsComponent = checkSectionValid(monthlyPaymentsSummary);
  const showProgramDescriptionComponent = checkSectionValid(programDescription) || !!offerNameProp;

  useEffect(() => {
    if (currentSubscriber !== undefined) {
      var programDescriptionBySubscriber = programDescription.programDescriptionDetails.filter(
        (description) => description.subscriber === currentSubscriber,
      );
      setProgramDetail(programDescriptionBySubscriber[0]?.programDescription);
      setOfferName(programDescriptionBySubscriber[0]?.offerName ?? offerNameProp);
    }
  }, [currentSubscriber, programDescription, offerNameProp]);

  if (showServicePaymentsComponent) {
    servicePayments = monthlyPaymentsSummary.servicePayments.map((service, idx) => {
      if (service.subscriber !== currentSubscriber && currentSubscriber != null) {
        return;
      }
      return (
        <div className='block-frame__list-info' key={idx.toString() + service.name}>
          <div className={checkRegularPayment(service.priceCycles) ? 'block-frame__row' : 'block-frame__row block-frame__row--1'}>
            <label>{service.name}</label>
            {setPriceCyclesDescription(service.priceCycles, '')}
          </div>
        </div>
      );
    });
  }

  return showProgramDescriptionComponent ? (
    <div className='program-details'>
      <label className='program-details__topic'>{title}</label>
      <label className='program-details__offer-name'>{offerName}</label>
      {generalDetails?.family === 'W' && pricePlanDetailDesc && (
        <p className='program-details__price-plan-detail-desc'>{pricePlanDetailDesc}</p>
      )}
      <p className='program-details__program-description'>{programDetail}</p>
      {showServicePaymentsComponent && (
        <div>
          <label className='program-details__topic'> סיכום עלויות חודשיות להזמנה זו </label>
          <div className='program-details__monthly-payments'>{servicePayments}</div>
        </div>
      )}
    </div>
  ) : null;
};

export default ProgramDetails;
